import { Component, input, output } from '@angular/core';
import { OfferCardComponent } from '../../../components/offer-card/offer-card.component';
import { CommonModule } from '@angular/common';
import { IAccommodationOfferShort } from '../../../interfaces/interface';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorComponentComponent } from 'src/app/components/error-component/error-component.component';

@Component({
  selector: 'app-letter-view',
  imports: [
    CommonModule,
    OfferCardComponent,
    MatProgressSpinnerModule,
    ErrorComponentComponent,
  ],
  templateUrl: './letter-view.component.html',
  styleUrl: './letter-view.component.scss',
})
export class LetterViewComponent {
  offers = [];

  clientName = input<string>();
  listOffers = input<IAccommodationOfferShort[] | null>();
  isConfirmedOfferForCurrentUser = input<boolean>();
  //errors
  isErrorRequest = input<boolean>();
  errorMessage = input<string>();

  goToOffer = output<number>();
}
